<mat-card appearance="outlined" class="dialog-card">
  <button class="close-btn" mat-icon-button (click)="onClose()" [attr.aria-label]="'common.close'|traduccion">
    <mat-icon>close</mat-icon>
  </button>

  <h2>{{'myWalletMovements.title'|traduccion}}</h2>


  <mat-form-field appearance="outline" class="filter-input">
    <mat-label>{{'myWalletMovements.filter'|traduccion}}</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="{{'myWalletMovements.filter.placeholder'|traduccion}}">
  </mat-form-field>

  <table mat-table [dataSource]="movements" class="mat-elevation-z2 full-width-table">


    <!-- description -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{'myWalletMovements.description'|traduccion}}</th>
      <td mat-cell *matCellDef="let element">{{ showDescriptionMovement(element.description) }}</td>
    </ng-container>

    <!-- type -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{'myWalletMovements.type'|traduccion}}</th>
      <td mat-cell *matCellDef="let element">{{ element.type }}</td>
    </ng-container>

    <!-- amount -->
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>{{'myWalletMovements.amount'|traduccion}}</th>
      <td mat-cell *matCellDef="let element">{{ element.amount|currency:'EUR' }}</td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>{{'myWalletMovements.createdAt'|traduccion}}</th>
      <td mat-cell *matCellDef="let element">{{ element.createdAt | date: appService.FORMAT_DATE }}</td>
    </ng-container>


    <!-- Header y filas -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <!-- 📑 Paginador -->
  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>


  <!-- Mensaje sin datos -->
  @if (movements.data.length === 0) {
    <div class="no-data">
      {{'noDataTable'|traduccion}}
    </div>
  }


</mat-card>
